import { Link, NavLink, Outlet } from 'react-router'

import { useCurrentUser } from '@/api/auth'
import { useVersion } from '@/api/service'
import { ThemeToggle } from '@/components/ThemeToggle'
import { UserMenu } from '@/features/auth/UserMenu'
import { strings } from '@/lib/strings'

function navClass({ isActive }: { isActive: boolean }): string {
  return isActive ? 'text-fg font-medium' : 'text-muted hover:text-fg'
}

export function Layout() {
  const version = useVersion()
  const { data: user } = useCurrentUser()

  return (
    <div className="flex min-h-dvh flex-col">
      <header className="border-b border-border bg-surface">
        <div className="mx-auto flex w-full max-w-6xl items-center gap-6 px-4 py-3">
          <Link to="/" className="font-semibold tracking-tight">
            {strings.appName}
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <NavLink to="/tasks" className={navClass}>
              {strings.nav.catalog}
            </NavLink>
            <NavLink to="/tracks" className={navClass}>
              {strings.nav.tracks}
            </NavLink>
            {/* Прогресс считается по своим задачам, поэтому гостю пункт
                не показывается: показывать нечего. */}
            {user !== undefined && user !== null && (
              <NavLink to="/progress" className={navClass}>
                {strings.nav.progress}
              </NavLink>
            )}
          </nav>
          <div className="ml-auto flex items-center gap-4">
            <UserMenu />
            <ThemeToggle />
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-8">
        <Outlet />
      </main>

      <footer className="border-t border-border px-4 py-3 text-center text-xs text-muted">
        {/* Версия из API — заодно наглядная проверка, что фронтенд действительно
            дотягивается до backend через прокси. */}
        {version.isError ? strings.service.apiUnreachable : `API ${version.data?.version ?? '…'}`}
      </footer>
    </div>
  )
}
